import { CsbHelper, getTemplateValues } from '@recruiting-solutions/rs-shared';
import { Component, h, Host, State, Prop, Element } from '@stencil/core';
import { ArvIcons } from 'apps/arv-components/src/global/arv-icons';

const i18n = getTemplateValues('header');
@Component({
    tag: 'arv-language-switcher',
    styleUrl: 'arv-language-switcher.scss',
    shadow: true,
})
export class ArvLanguageSwitcher {
    @Element() element;
    @State() locale: string;
    @State() isDropDownOpen: boolean = false;
    @Prop() theme: 'black' | 'white' = 'black';
    @Prop()
    languages: { code: string; label: string; isLast?: boolean }[] = [
        { code: 'en_US', label: 'English' },
        { code: 'de_DE', label: 'Deutsch' },
        { code: 'nl_NL', label: 'Nederlands' },
        { code: 'pl_PL', label: 'Polski' },
        // { code: 'tr_TR', label: 'Türkçe' },
        { code: 'es_ES', label: 'Español' },
        { code: 'it_IT', label: 'Italiano' },
        // { code: 'pt_BR', label: 'Português' },
        { code: 'fr_FR', label: 'Français', isLast: true },
    ];

    componentWillLoad() {
        this.locale = CsbHelper.getLocale();
    }

    render() {
        if (this.isApplyPage() || this.isPostingPage() || this.isDCFPage()) {
            return <Host></Host>;
        }
        return (
            <Host class={{ [this.theme]: true }}>
                <button
                    class="world"
                    title={i18n('language')}
                    aria-label={i18n('language')}
                    aria-expanded={this.isDropDownOpen.toString()}
                    tabIndex={0}
                    onKeyDown={event => {
                        if (event.key === 'Enter') {
                            this.toggleDropdown(event);
                        }
                    }}
                    onMouseOver={() => this.setDropdown(true)}
                    onMouseLeave={() => this.setDropdown(false)}
                    onTouchStart={() => this.toggleDropdown()}
                >
                    {ArvIcons.getGeneric('world', 'var(--icon-color)', undefined, 'world-icon')}
                </button>
                <div onMouseOver={() => this.setDropdown(true)} onMouseLeave={() => this.setDropdown(false)} class="dropdown">
                    <ul>
                        {this.languages.map(lang => (
                            <li>
                                <a
                                    tabIndex={0}
                                    class={this.locale === lang.code ? 'selected' : ''}
                                    onClick={() => this.updateLocale(lang.code)}
                                    title={this.locale === lang.code ? i18n('languageSelectedText') + ' ' + lang.label : i18n('languageText') + ' ' + lang.label}
                                    onKeyDown={event => {
                                        if (event.key === 'Enter') {
                                            this.updateLocale(lang.code);
                                        }
                                    }}
                                    onBlur={() => lang.isLast && this.setDropdown(false)}
                                >
                                    {lang.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </Host>
        );
    }

    toggleDropdown(event?: Event) {
        const el = this.element.shadowRoot.querySelector('.dropdown') as HTMLDivElement;
        el.classList.toggle('open');
        this.isDropDownOpen = !this.isDropDownOpen;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    setDropdown(state?: boolean) {
        const el = this.element.shadowRoot.querySelector('.dropdown') as HTMLDivElement;
        this.isDropDownOpen = state ?? false;
        if (!state) {
            el.classList.remove('open');
        } else {
            el.classList.add('open');
        }
    }

    updateLocale(locale: string) {
        sessionStorage.setItem('disableLanguagePopup', 'true');
        window.location.href = this.replaceLocale(locale);
    }

    private replaceLocale(locale: string) {
        let url: string = window.location.href;
        const uri = new URL(url);
        uri.searchParams.set('locale', locale);
        uri.searchParams.set('path', locale);
        return uri.toString();
    }

    isPostingPage() {
        return document?.body.classList.contains('arv-job-posting-page');
    }

    isApplyPage() {
        return document?.body.classList.contains('arv-apply-page');
    }

    isDCFPage() {
        return document?.body.classList.contains('landing-page');
    }
}
